/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Location {
    angular.module('meevo.plugins.location', []);
}